import { ISettings } from './types';

function getFeedUrl(settings: ISettings, wixDefaultFeedUrl?: string): string {
  return settings.feedUrl || settings.defaultFeedUrl || wixDefaultFeedUrl;
}

export default getFeedUrl;
